export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/c2306b84732d2ffd8873336040e7c04e.jpg"
          alt="Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      {/* Geometric Overlay Elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-10 w-64 h-64 border border-cyan-500/30 rotate-45"></div>
        <div className="absolute bottom-32 right-20 w-96 h-96 border border-cyan-500/20 rotate-12"></div>
        <div className="absolute top-1/2 left-1/3 w-48 h-48 border border-cyan-500/25"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center w-full">
        <h1 className="text-6xl md:text-7xl font-bold mb-6 tracking-tight leading-tight">
          Operational Excellence,<br />
          <span className="text-cyan-400">Executed Quietly</span>
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed">
          MR Prime Ops helps creators monetize their audience with precision.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-5 mb-8">
          <button 
            onClick={scrollToContact}
            className="px-8 py-4 bg-cyan-500 text-black text-base font-bold rounded-md hover:bg-cyan-400 transition-all shadow-lg hover:shadow-cyan-500/50 whitespace-nowrap cursor-pointer"
          >
            Book a Call
          </button>
        </div>

        <p className="text-sm text-gray-400 font-mono">mrprimeops.com</p>
      </div>

      {/* Bottom Gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black to-transparent"></div>
    </section>
  );
}
